import React from 'react';
import { TextField, Box } from '@mui/material';

/**
 * CustomerSearchBar - A presentational component for searching customers
 * 
 * @param {Object} props
 * @param {string} props.searchTerm - The current search term
 * @param {Function} props.onSearchChange - Callback when search term changes
 */
const CustomerSearchBar = ({ searchTerm, onSearchChange }) => {
  const handleChange = (event) => {
    onSearchChange(event.target.value);
  };

  return (
    <Box sx={{ mb: 2, width: '100%', maxWidth: 600 }}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search by customer name or code..."
        value={searchTerm}
        onChange={handleChange}
        size="medium"
        aria-label="Search customers"
      />
    </Box>
  );
};

export default CustomerSearchBar;
